import { Box, Center, Spinner } from '@chakra-ui/react';
import { getCoreRowModel, useReactTable } from '@tanstack/react-table';

import { ResourceType } from '../../_openapi/portfolio-optimizer';
import { usePositions } from '../../api/position';
import { positionListColumns } from '../../Position/positionListColumns';
import { Pagination } from '../../widgets/Table/Pagination';
import { Table } from '../../widgets/Table/Table';
import { TableControls } from '../../widgets/Table/TableControls';
import { useTableColumnSettings } from '../../widgets/Table/useTableColumnSettings';
import { useTableState } from '../../widgets/Table/useTableState';

export const PortfolioPositionsTableTab = ({ pId }: { pId: string }) => {
    const { pagination, setPagination, sorting, setSorting, columnFilters, setColumnFilters } = useTableState({
        columns,
        initialSort: [{ id: 'grossExposure', desc: true }],
        initialFilters: [{ id: 'pId', value: pId }],
    });

    const { data, isPending } = usePositions({ dataVariant: 'preTrade', pagination, columnFilters, sorting });

    const { columnVisibility, setColumnVisibility, columnOrder, setColumnOrder } =
        useTableColumnSettings('portfolioPositions');

    const table = useReactTable({
        data: data?.positions || [],
        columns,
        state: {
            columnVisibility,
            columnOrder,
            pagination,
            sorting,
            columnFilters,
        },
        onColumnFiltersChange: setColumnFilters,
        onColumnVisibilityChange: setColumnVisibility,
        onColumnOrderChange: setColumnOrder,
        onPaginationChange: setPagination,
        onSortingChange: setSorting,
        getCoreRowModel: getCoreRowModel(),
        manualPagination: true,
        manualSorting: true,
        manualFiltering: true,
        sortDescFirst: false,
    });

    if (isPending) {
        return (
            <Center width="100%" height="40vh">
                <Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="teal.500" size="lg" />
            </Center>
        );
    }

    return (
        <Box>
            <TableControls
                table={table}
                resourceType={ResourceType.POSITION}
                metaData={{ positionType: 'pre_trade' }}
            />
            <Table table={table} allowXOverflow />
            <Pagination table={table} totalItems={data?.totalNr} />
        </Box>
    );
};

const EXCLUDE_COLUMNS = ['tradeDate', 'pId', 'portfolioGuid', 'aC', 'accountAlias', 'portfolioName', 'householdName'];
const columns = positionListColumns.filter((col) => col.id && !EXCLUDE_COLUMNS.includes(col.id));
